import React from 'react';
import { RsSelect, SelectDataType } from 'components/Rsuite/Select';
import styles from './brandSelection.module.scss';
import { useCampaignStore } from 'store/campaignStore';

interface Ipros {
  values: any;
  brandOptions: SelectDataType[];
  errorMessage?: string;
  onChange: (webBrandNo: string) => void;
}

const BrandSelection: React.FC<Ipros> = ({
  values,
  brandOptions,
  errorMessage,
  onChange,
}) => {
  const { actionType } = useCampaignStore();

  // 選擇品牌
  const handleChange = (webBrandNo) => {
    onChange(webBrandNo);
  };

  const brandLabel = () => {
    return (
      brandOptions.find((brand) => brand.value === values.basic?.webBrandNo)
        ?.label || values.basic?.webBrandNo
    );
  };

  return (
    <RsSelect
      data={brandOptions}
      value={values.basic?.webBrandNo}
      onChange={handleChange}
      className={styles['brand-select']}
      placeholder='請選擇'
      errorMessage={errorMessage}
      cleanable={false}
      disabled={actionType === 'edit'}
      renderValue={() => <span className='text-ellipsis'>{brandLabel()}</span>}
    />
  );
};

export default BrandSelection;
